{
  "pipeline.description": "{open} open deals · {won} won. Drag a card to move it, or open it to pick a stage.",
  "pipeline.deal": "Deal",
  "pipeline.stage": "Stage",
  "pipeline.history": "Stage history",
  "pipeline.noHistory": "Still in its first stage.",
  "pipeline.ownedBy": "Owned by {name}",
  "pipeline.openClient": "Open the client's profile",
  "pipeline.addRequest": "Add a buyer request",
  "pipeline.intent.buy": "Buyer",
  "pipeline.intent.sell": "Seller",
  "pipeline.filter.intent": "Intent",
  "pipeline.filter.owner": "Owner",
  "pipeline.col.client": "Client",
  "pipeline.col.updated": "Last moved",
  "pipeline.view.board": "Board",
  "pipeline.view.list": "List",
  "pipeline.card.role": "Draggable deal",
  "pipeline.dropHere": "Drop a deal here",
  "pipeline.moved": "{name} moved to {stage}",
  "pipeline.moveFailed": "The deal couldn't be moved. It's back where it was.",
  "pipeline.undo": "Undo",
  "pipeline.empty.title": "No deals yet",
  "pipeline.empty.body": "Deals open when a lead, cold call or owner is marked “Interested to buy” or “Interested to sell”."
}
